import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PlaceAdService } from '@core/services/place-ad.service';
import { StorageService } from '@core/services/storage.service';
import * as Sentry from '@sentry/angular-ivy';
import { LocaleService } from '@shared/services/locale.service';
import { AuthService } from '@shared/services/auth.service';
import { AmplitudeService } from '../services/amplitude.service';
import { SeoService } from '../services/seo.service';
import { initAmplitudeFactory, initAuthFactory, initLocaleFactory, initPlaceAdFactory, initSentryFactory, initSeoFactory } from './app.initializer';
import { initMatIconRegistryFactory } from './mat-icon.initializer';

export const APP_INITIALIZERS: any = [
	{
		provide: APP_INITIALIZER,
		useFactory: initAmplitudeFactory,
		deps: [AmplitudeService, AuthService],
		multi: true,
	},

	{
		provide: APP_INITIALIZER,
		useFactory: initSeoFactory,
		deps: [SeoService, Router],
		multi: true,
	},

	{
		provide: APP_INITIALIZER,
		useFactory: initAuthFactory,
		deps: [AuthService, StorageService],
		multi: true,
	},

	{
		provide: APP_INITIALIZER,
		useFactory: initPlaceAdFactory,
		deps: [PlaceAdService, Router],
		multi: true,
	},

	{
		provide: APP_INITIALIZER,
		useFactory: initLocaleFactory,
		deps: [LocaleService, StorageService],
		multi: true,
	},

	{
		provide: APP_INITIALIZER,
		useFactory: initMatIconRegistryFactory,
		deps: [MatIconRegistry, DomSanitizer],
		multi: true,
	},

	/**
	 * SENTRY
	 * TODO: Create a seperate file for Sentry
	 */
	{
		provide: APP_INITIALIZER,
		useFactory: initSentryFactory,
		deps: [],
		multi: true,
	},
	{
		provide: ErrorHandler,
		useValue: Sentry.createErrorHandler({
			showDialog: true,
		}),
	},
	{
		provide: Sentry.TraceService,
		deps: [Router],
	},
	{
		provide: APP_INITIALIZER,
		useFactory: () => () => {},
		deps: [Sentry.TraceService],
		multi: true,
	},
	// end - SENTRY
];
